/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WaitlistRow } from './WaitlistRow';
import {
    WaitlistRowFromJSON,
    WaitlistRowFromJSONTyped,
    WaitlistRowToJSON,
    WaitlistRowToJSONTyped,
} from './WaitlistRow';

/**
 * 
 * @export
 * @interface WaitlistWidgetData
 */
export interface WaitlistWidgetData {
    /**
     * 
     * @type {Array<WaitlistRow>}
     * @memberof WaitlistWidgetData
     */
    items: Array<WaitlistRow>;
}

/**
 * Check if a given object implements the WaitlistWidgetData interface.
 */
export function instanceOfWaitlistWidgetData(value: object): value is WaitlistWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WaitlistWidgetDataFromJSON(json: any): WaitlistWidgetData {
    return WaitlistWidgetDataFromJSONTyped(json, false);
}

export function WaitlistWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WaitlistRowFromJSON)),
    };
}

export function WaitlistWidgetDataToJSON(json: any): WaitlistWidgetData {
    return WaitlistWidgetDataToJSONTyped(json, false);
}

export function WaitlistWidgetDataToJSONTyped(value?: WaitlistWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(WaitlistRowToJSON)),
    };
}

